/**
 * Crop an image given a source URL and pixel crop coordinates.
 * Compatible with react-image-crop's pixel crop output.
 * Returns a base64 data URL of the cropped image.
 */
export async function getCroppedImg(imageSrc, pixelCrop) {
  const image = await createImage(imageSrc);
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');

  if (!ctx) {
    throw new Error('Could not get canvas context');
  }

  // Set canvas dimensions to the cropped area
  canvas.width = pixelCrop.width;
  canvas.height = pixelCrop.height;

  // Draw the cropped portion of the image
  ctx.drawImage(
    image,
    pixelCrop.x,
    pixelCrop.y,
    pixelCrop.width,
    pixelCrop.height,
    0,
    0,
    pixelCrop.width,
    pixelCrop.height
  );

  // Return as PNG for better quality
  return canvas.toDataURL('image/png');
}

/**
 * Create an Image element from a URL.
 * Handles both data URLs and remote URLs with CORS.
 */
function createImage(url) {
  return new Promise((resolve, reject) => {
    const image = new Image();
    
    // Only set crossOrigin for non-data URLs
    if (!url.startsWith('data:')) {
      image.crossOrigin = 'anonymous';
    }
    
    image.addEventListener('load', () => resolve(image));
    image.addEventListener('error', (error) => {
      console.error('Error loading image for crop:', error);
      reject(new Error('Failed to load image for cropping'));
    });
    
    image.src = url;
  });
}
